import {  ResizeableType, WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import WebDesigner from "../WebDesigner";
import CreateAttributeList, { attributeTypes} from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { RowIcon } from "../Icons/ComponentIcons";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";





export default class Row extends WBComponent {


    constructor() {
        super();
        this.typename = wBComponentTypeNames.row
        this.dropList = [wBComponentTypeNames.pageRoot,wBComponentTypeNames.section, wBComponentTypeNames.column,wBComponentTypeNames.footer,wBComponentTypeNames.navigationBar];
        this.displayName= "Row";
        this.editList = [
            "justifyHorizontal","alignVertical",
            attributeTypes.justifyContent,attributeTypes.alignContent,attributeTypes.alignItems,
           attributeTypes.flexGrow,
            attributeTypes.width,
            ...CreateAttributeList(true,true,true,false,true,false),
        ];
        this.primaryEditAttributes = [attributeTypes.flexGrow, "justifyHorizontal","alignVertical",attributeTypes.gap];
        
     
        
        this.resizeType = ResizeableType.flexGrow;
        this.icon = <RowIcon/>
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {

        if(newParent.typename == wBComponentTypeNames.column){
            let  dup = super.duplicateSelfOnCreation(newParent,thisLayout,manager);

            if(dup){
                dup.screenSizeStyleAttributes[ScreenSize.Desktop] = {gap:"4px"};
                dup.componentAttributes = {horizontalAlign:"center",verticalAlign:"center"};
            }
        }
       thisLayout.screenSizeStyleAttributes[ScreenSize.Desktop] = {gap:"4px",justifyContent:"center",alignItems:"center",alignContent:"center"};
 
      }
    RenderLayout({component,children,screenSize,isEditor}:WBRenderProps){
        // const horizontal = component.componentAttributes['horizontalAlign']??"center";
        // const vertical = component.componentAttributes['verticalAlign']??"center";
      
        // setNodeStyleAttributeValue(component,ScreenSize.Desktop,attributeTypes.justifyContent,horizontal);
        // setNodeStyleAttributeValue(component,ScreenSize.Desktop,attributeTypes.alignContent,vertical);
        // setNodeStyleAttributeValue(component,ScreenSize.Desktop,attributeTypes.alignItems,vertical);
       
        return <div {...GetNodeDomAttributes("v-row ",component,screenSize,isEditor)}>
            {children}
        </div>
    }


}